// Which products are in view, for the dots: one dot per product, the ones in view are colored.
// `start` is the first product in view (Swiper's realIndex in loop mode, activeIndex otherwise).
export default function visibleProducts (start, perView, total, loop) {
  const count = Math.min(Math.max(1, Math.round(perView)), total)
  const first = loop ? start : Math.min(start, total - count)
  const indexes = []
  for (let i = 0; i < count; i++) {
    indexes.push(loop ? (first + i) % total : first + i)
  }
  return indexes
}
